import { averageDetail, parseStatKey, statValue } from "../../core/stats";
import { formatMs, formatSolve } from "../../core/time";
import { TRIM_PERCENT } from "../../core/types";
import { openModal, selectSolve, useProfileSolves } from "../../state/store";
import { useStats } from "../../state/useStats";
import { Icon, Modal } from "./Modal";
import { copyText } from "../TimerScreen";

export function AverageDetail({ statKey, end }: { statKey: string; end: number }) {
  const solves = useProfileSolves();
  const stats = useStats();
  const spec = parseStatKey(statKey);

  if (!spec || end < spec.n - 1 || end >= solves.length) {
    return (
      <Modal title={statKey} size="sm">
        <p className="muted">Not enough solves for this average.</p>
      </Modal>
    );
  }

  const detail = averageDetail(stats.values, end, spec, TRIM_PERCENT);
  const value = statValue(detail.value);
  const window = solves.slice(detail.start, detail.end + 1);

  const lines = window.map((s, k) => {
    const i = detail.start + k;
    const t = formatSolve(s.time, s.penalty);
    const shown = detail.trimmed.has(i) ? `(${t})` : t;
    return `${k + 1}. ${shown}   ${s.scramble.replace(/\n/g, " ")}`;
  });
  const text = [
    "Generated by KubeTimr",
    `${spec.key}: ${value === undefined ? "–" : formatMs(value)}`,
    "",
    "Time List:",
    ...lines,
  ].join("\n");

  return (
    <Modal
      title={
        <>
          {spec.key} <span className="modal__title-value">{value === undefined ? "–" : formatMs(value)}</span>
        </>
      }
      size="md"
      footer={
        <>
          <span className="muted small">
            Solves {detail.start + 1} to {detail.end + 1}
            {spec.kind === "ao" ? ` · ${detail.trimmed.size / 2} trimmed each side` : ""}
          </span>
          <span className="spacer" />
          <button className="btn btn--ghost" onClick={() => copyText(text, "Average copied.")}>
            <Icon name="copy" size={14} /> Copy
          </button>
        </>
      }
    >
      <ol className="avg-list" start={1}>
        {window.map((s, k) => {
          const i = detail.start + k;
          const trimmed = detail.trimmed.has(i);
          return (
            <li key={s.id} className={trimmed ? "is-trimmed" : ""}>
              <button
                className="avg-list__time"
                onClick={() => {
                  selectSolve(s.id);
                  openModal({ kind: "solve", id: s.id });
                }}
              >
                {trimmed ? `(${formatSolve(s.time, s.penalty)})` : formatSolve(s.time, s.penalty)}
              </button>
              <span className="avg-list__scramble">{s.scramble}</span>
            </li>
          );
        })}
      </ol>
    </Modal>
  );
}
